import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'lib-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.css']
})
export class ToolbarComponent implements OnInit {

    @Input()
    availableColors: ChipColor[];

    public menuActions: MenuElements[] = [];

    constructor() {
    }

    ngOnInit(): void {
        this.setupMenu();
    }

    setupMenu() {
        this.menuActions = [];
        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'Asociar actuación',
            icon: 'move_to_inbox',
            customIcon: false
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'PDF de actuación',
            icon: 'info',
            customIcon: false
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'Solicitar información adicional',
            customIcon: false,
            icon: 'info'
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'Información solicitada',
            customIcon: false,
            icon: 'contact_support'
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'PDF de respuesta',
            icon: 'move_to_inbox',
            customIcon: false
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'PDF de solicitud',
            icon: 'outbox',
            customIcon: true
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'Ver detalle de expediente',
            icon: 'remove_red_eye'
        });

        this.menuActions.push({
            show: true,
            click: this.mostrarConsola,
            tooltip: 'Solicitar acceso al detalle del expediente',
            icon: 'vpn_key',
            customIcon: false
        });
    }

    mostrarConsola() {
        console.log("opciones toolbar");
    }

    menuIsEmpty = (): boolean => {
        return this.menuActions.every((action) => !action.show);
    }
}

export interface ChipColor {
    name: string;
    color: string;
    backgroundColor: string;
}

export interface MenuElements {
    show: boolean;
    click: () => void;
    tooltip: string;
    icon: string;
    customIcon?: boolean;
    disabled?: boolean;
}
